// Utility: Assert never
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function isNever(_: never): void {}
